"use strict";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.directive("obsSdisMap", function (leaflet, leafletDefaultConfig, leafletUtils, ObsStratManager, obsUtils, directiveUtils,
                                           $timeout) {
    return {
        restrict: "A",
        scope: true,
        require: ["obsSdisMap", "obsLeafletMap", "^obsSdisManager"],
        link: function ($scope, $el, $attrs, controllers) {
            var ctrl = controllers[0],
                mapCtrl = controllers[1],
                mapManagerCtrl = controllers[2];

            mapCtrl.setUpdateHandler(ctrl.updateData);
            ctrl.initialize(mapCtrl, mapManagerCtrl);
        },
        controller: function ($scope, $element) {

            var ctrl = this,
                mapCtrl = null,
                managerCtrl = null;

            var geoManager = new ObsStratManager({}),
                geoConfig = geoManager.getConfig();

            ctrl.initialize = function (_mapCtrl, _managerCtrl) {
                mapCtrl = _mapCtrl;
                managerCtrl = _managerCtrl;

                // need to wait for the map to be here... didnt found a proper way, so we watch the same condition once.
                var unwatch = $scope.$watch("mapConfig", function (mapConfig) {
                    if (mapConfig != null) {
                        unwatch();
                        $timeout(addSearchFieldControl, 1);
                    }
                });
            };

            var legend,
                searchControl,
                shortcuts,
                contextInfo,
                tooltipElement,
                selectedLayer;

            ctrl.updateData = function (infoCommune) {
                mapCtrl.getMap().then(function (map) {
                    if (shortcuts == null) {
                        shortcuts = leafletUtils.addShortcuts($scope, $element, leaflet, map);
                    }

                    // initialize contextInfo
                    if (contextInfo == null) {
                        addContextInfoControl(map);
                    }
                    if (tooltipElement == null) {
                        createTooltipElement();
                    }

                    // refresh manager
                    geoManager.setStrates(infoCommune.strates);

                    // create legend
                    if (legend != null) {
                        legend.remove();
                    }
                    legend = geoManager.generateLegend();
                    map.addControl(legend);

                    // creates geojson layout

                    generateGeoJson(map, infoCommune);

                });
            };

            var addContextInfoControl = function (map) {
                var linkFn = directiveUtils.compileDirective("obsSdisMapContextInfo");
                var contentEl = null;
                linkFn($scope, function (clone) {
                    clone.appendTo($element);
                    contentEl = clone;
                });
                contextInfo = leaflet.control({
                    position: "bottomleft"
                });
                contextInfo.onAdd = function () {
                    return contentEl[0];
                };
                contextInfo.addTo(map);
            };

            var createTooltipElement = function () {
                var linkFn = directiveUtils.compileDirective("obsSdisMapTooltip");
                linkFn($scope, function (clone) {
                    clone.appendTo($element);
                    tooltipElement = clone[0];
                });
            };

            var addSearchFieldControl = function () {
                mapCtrl.getMap().then(function (map) {
                    searchControl = leaflet.control({
                        position: "topleft"
                    });
                    searchControl.onAdd = function () {
                        var searchWrapper = $("<div>").addClass("leaflet-control-search-field");
                        var searchFieldLink = directiveUtils.compileDirective("obsSdisSearchField");
                        var searchField;
                        searchFieldLink($scope, function (_searchField) {
                            searchField = _searchField;
                            searchField.appendTo($element);
                        });
                        searchField.appendTo(searchWrapper);
                        // avoid scrolling map when in widget
                        _.each(["mousedown", "mouseup", "mousewheel"], function (eventName) {
                            searchWrapper.bind(eventName, function (e) {
                                e.stopPropagation();
                            });
                        });
                        return searchWrapper[0];
                    };
                    searchControl.addTo(map);
                });
            };

            var generateGeoJson = function (map, infoMapCommune) {

                var getSelectedId = function () {
                    return managerCtrl.getSelectedId();
                };

                // Afficher les nom et données sur la carte directement
                if ($scope.labels) {

                    for (const label of $scope.labels) {
                        map.removeLayer(label);
                    }

                }
                $scope.labels = [];


                _.extend($scope, {
                    geojson: {
                        data: infoMapCommune.features,
                        onEachFeature: function (feature, layer) {

                            var featureId = feature.properties.id;

                            var style = geoManager.getGeoStyle(feature);
                            if (featureId === getSelectedId()) {
                                selectedLayer = layer;
                                _.extend(style, geoConfig.selectedStyle);
                            }

                            if ($scope.reference != null && featureId === $scope.reference.id) {
                                _.extend(style, geoConfig.referenceStyle);
                            }

                            layer.setStyle(style);

                            layer.bindTooltip(tooltipElement, {
                                sticky: true,
                                direction: 'right',
                                offset: [20, 0],
                            });

                            // Afficher les nom et données sur la carte directement
                            // ajout de labels

                            if ($scope.communeParams.label && map.getZoom() > 6) {
                                let value = feature.properties.value;
                                value = obsUtils.formatValue($scope.communeParams, value);

                                var label = L.marker(layer.getBounds().getCenter(), {
                                    icon: L.divIcon({
                                        className: 'label-layer-carto',
                                        html: '<div class="detail-carto"><div>' + feature.properties.nom + '</div><div>' + value + '</div></div>',
                                        iconSize: [100, 40],

                                    })
                                }).addTo(map);
                                $scope.labels.push(label);
                            }


                            layer.on("click", function (e) {

                                // uniquement pour le public : changement de référence sur le click
                                if (managerCtrl.getConfig().publicObs) {
                                    selectArea(featureId, layer);
                                    // sur le public, on ne recentre pas sur la référence suite au click pour ne pas déclencher de rechargement des contours
                                    managerCtrl.loadReference(featureId, false);
                                    managerCtrl.refreshData(); // La valeur pour la référence doit être mise à jour (TAEL-1163)
                                } else if (featureId === getSelectedId()) {
                                    managerCtrl.setSelectedId(null);
                                    selectedLayer = null;
                                    layer.setStyle(geoConfig.defaultStyle);
                                } else {
                                    selectArea(featureId, layer);
                                }
                            });

                            layer.on("mouseover", function (e) {
                                managerCtrl.setHoveredCommune(feature.properties);
                                layer.setStyle(geoConfig.hoverStyle);
                            });

                            layer.on("mouseout", function (e) {
                                managerCtrl.setHoveredCommune(null);

                                if ($scope.reference != null && featureId === $scope.reference.id) {
                                    layer.setStyle(geoConfig.referenceStyle);
                                } else if (featureId === getSelectedId()) {
                                    layer.setStyle(geoConfig.selectedStyle);
                                } else {
                                    layer.setStyle(geoConfig.defaultStyle);
                                }
                            });
                        }
                    }
                });

                var selectArea = function (featureId, layer) {
                    if (selectedLayer) {
                        selectedLayer.setStyle(geoConfig.defaultStyle);
                    }
                    managerCtrl.setSelectedId(featureId);
                    selectedLayer = layer;
                    layer.setStyle(geoConfig.selectedStyle);
                };

            };

        }
    };
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/sdis/obsSdisMap.js